import React from 'react';
import { useClinicalReports } from '../../clinical-reports/ClinicalReportsContext';
import ReportSectionHead from '../../head-doctor/reports/ReportSectionHead';
import { NursingVaccineReportSection } from '../../head-doctor/reports/nursingReportSections';

export default function MajorReportsVaccinsPage() {
  const { data, summary, loading, copy: COPY, hasActiveAdvancedFilters, clearAdvancedFilters } =
    useClinicalReports();

  return (
    <>
      <ReportSectionHead
        badge={COPY.SUB_VACCINS}
        title={COPY.PAGE_VACCINS_TITLE}
        description={COPY.PAGE_VACCINS_DESC}
      />

      <NursingVaccineReportSection
        data={data}
        summary={summary}
        loading={loading}
        copy={COPY}
        emptyHint={COPY.EMPTY_FILTERED_HINT}
        clearFiltersLabel={COPY.EMPTY_CLEAR_FILTERS}
        onClearFilters={hasActiveAdvancedFilters ? clearAdvancedFilters : null}
      />
    </>
  );
}
